<template>
  <div class="tw:w-full tw:max-w-[1440px] tw:mx-auto tw:py-10 tw:px-8">
    <h1 class="tw:text-3xl tw:font-bold tw:mb-2">Design System</h1>
    <p class="tw:text-sm tw:opacity-60 tw:mb-10">Catálogo interativo dos componentes da pasta <code class="tw:bg-black/10 tw:px-1.5 tw:py-0.5 tw:rounded tw:text-xs">atomic/</code></p>

    <section class="tw:mb-12">
      <h2 class="tw:text-xl tw:font-semibold tw:mb-5">Atoms</h2>
      <div class="tw:grid tw:grid-cols-2 md:tw:grid-cols-3 lg:tw:grid-cols-4 tw:gap-3">
        <router-link
          v-for="item in atoms"
          :key="item.route"
          :to="item.route"
          class="tw:block tw:p-5 tw:rounded-xl tw:border tw:border-gray-200 tw:hover:border-blue-400 tw:hover:shadow-sm tw:transition-all"
        >
          <span class="tw:font-medium tw:text-sm">{{ item.name }}</span>
        </router-link>
      </div>
    </section>

    <section>
      <h2 class="tw:text-xl tw:font-semibold tw:mb-5">Molecules</h2>
      <div class="tw:grid tw:grid-cols-2 md:tw:grid-cols-3 lg:tw:grid-cols-4 tw:gap-3">
        <router-link
          v-for="item in molecules"
          :key="item.route"
          :to="item.route"
          class="tw:block tw:p-5 tw:rounded-xl tw:border tw:border-gray-200 tw:hover:border-blue-400 tw:hover:shadow-sm tw:transition-all"
        >
          <span class="tw:font-medium tw:text-sm">{{ item.name }}</span>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
const atoms = [
  { name: 'AvatarPlay', route: '/ds/avatar-play' },
  { name: 'BadgePlay', route: '/ds/badge-play' },
  { name: 'CheckboxPlay', route: '/ds/checkbox-play' },
  { name: 'DividerPlay', route: '/ds/divider-play' },
  { name: 'IconGoogle', route: '/ds/icon-google' },
  { name: 'InfiniteScrollPlay', route: '/ds/infinite-scroll-play' },
  { name: 'InputColorPlay', route: '/ds/input-color-play' },
  { name: 'InputPlayV3', route: '/ds/input-play-v3' },
  { name: 'InputRadioPlay', route: '/ds/input-radio-play' },
  { name: 'InputRangePlay', route: '/ds/input-range-play' },
  { name: 'ProgressBarPlay', route: '/ds/progress-bar-play' },
  { name: 'TextareaPlayV2', route: '/ds/textarea-play-v2' },
  { name: 'TextPlay', route: '/ds/text-play' },
  { name: 'ToggleButtonPlay', route: '/ds/toggle-button-play' },
]

const molecules = [
  { name: 'BreadcrumbPlay', route: '/ds/breadcrumb-play' },
  { name: 'ButtonPlayV2', route: '/ds/button-play-v2' },
  { name: 'DatePickerPlay', route: '/ds/date-picker-play' },
  { name: 'DropdownPlay', route: '/ds/dropdown-play' },
  { name: 'FieldPlay', route: '/ds/field-play' },
  { name: 'FormFieldPlay', route: '/ds/form-field-play' },
  { name: 'ImagePickerPlay', route: '/ds/image-picker-play' },
  { name: 'InputDateTimePlay', route: '/ds/input-date-time-play' },
  { name: 'ModalPlay', route: '/ds/modal-play' },
  { name: 'MultiselectPlayV2', route: '/ds/multiselect-play-v2' },
  { name: 'PaginationPlay', route: '/ds/pagination-play' },
  { name: 'SelectPlayV2', route: '/ds/select-play-v2' },
  { name: 'StarRatingPlay', route: '/ds/star-rating-play' },
  { name: 'TabsPlayV2', route: '/ds/tabs-play-v2' },
  { name: 'TelInputPlay', route: '/ds/tel-input-play' },
  { name: 'TextEditorPlay', route: '/ds/text-editor-play' },
  { name: 'ToastPlay', route: '/ds/toast-play' },
]
</script>
